import React, { Component, PropTypes } from "react";
import { menuItemsData, eventType } from "constants/menuItemsData";
import MenuItems from "./MenuItems";
import { types } from "constants/types";
import { getTypeItemsByTypeAsync } from "actions/type-items";
import { routeCodes, subRouteCodes, routeParams } from "constants/routes";
import { getRecentDesignsAsync } from "actions/recentDesigns";

class Navbar extends Component {
  static propTypes = {
    typeItems: PropTypes.object,
    recentDesigns: PropTypes.object,
    dispatch: PropTypes.func,
    design: PropTypes.object,
    designs: PropTypes.object,
    userData: PropTypes.object,
    currentBrand: PropTypes.object,
  };

  componentWillMount() {
    const { dispatch } = this.props;
    dispatch(getTypeItemsByTypeAsync(types.DESIGN.TEXT_KEY));
    dispatch(getRecentDesignsAsync());
  }

  updateMenuItems(typeItemsData, designsData) {
    let designMenuItems = [
      {
        title: "Create New",
        url: "/designs",
        isCallFunc: false,
        eventType: "",
        payload: null,
        isHighlighted: true,
      },
    ];
    let recentDesignMenuItems = [
      {
        title: "Open Recent",
        url: "/designs",
        isCallFunc: false,
        eventType: "",
        payload: null,
        isHighlighted: true,
      },
    ];
    typeItemsData.forEach((item) => {
      designMenuItems.push({
        title: item.get("typeItemName"),
        url: `${routeCodes.DESIGNS}${subRouteCodes.DESIGNS.MANAGE_DESIGN}/${routeParams.MANAGE_DESIGN.TYPE_SIZE}`,
        isCallFunc: true,
        eventType: eventType.CREATE_NEW_DESIGN,
        payload: {
          id: item.get("id"),
        },
      });
    });

    menuItemsData[0].submenu[0].submenu = designMenuItems;
    designsData.forEach((item) => {
      recentDesignMenuItems.push({
        title: item.get("title"),
        url: "",
        isCallFunc: true,
        eventType: eventType.RECENT_DESIGN,
        payload: {
          id: item.get("id"),
        },
      });
    });

    menuItemsData[0].submenu[1].submenu = recentDesignMenuItems;
    return menuItemsData;
  }

  render() {
    const {
      typeItems,
      recentDesigns,
      design,
      designs,
      userData,
      dispatch,
      currentBrand,
    } = this.props;
    const depthLevel = 0;
    const menuItemArray = this.updateMenuItems(typeItems, recentDesigns);

    return (
      <nav className="desktop-nav">
        <ul className="menus">
          {menuItemArray.map((menu, index) => (
            <MenuItems
              items={menu}
              key={index}
              depthLevel={depthLevel}
              design={design}
              designs={designs}
              userData={userData}
              dispatch={dispatch}
              typeItems={typeItems}
              currentBrand={currentBrand}
            />
          ))}
        </ul>
      </nav>
    );
  }
}

export default Navbar;
